import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import { emptyArray } from 'src/utils/helpers';
import './style.scss';

interface IProps {
  colorsRowNumber: number;
  includeThemePicker?: boolean;
  includeCssBlock?: boolean;
}

const ConsumerChannelsConfigSkeletons: FC<IProps> = ({ colorsRowNumber, includeThemePicker, includeCssBlock }: IProps): JSX.Element => {
  return (
    <div className="d-flex flex-column mt-4 gap-20">
      {includeThemePicker ? <Skeleton width={240} height={46} style={{ borderRadius: 12 }} /> : null}

      <Skeleton width={450} height={19.2} style={{ borderRadius: 8 }} />

      <div className="d-flex flex-row gap-30">
        <div className="colors-channels-config-skeletons__list">
          {emptyArray(colorsRowNumber).map((item, index) => (
            <div key={'skeleton-' + String(index)} className="colors-channels-config-skeletons__row">
              <Skeleton width={200} height={21.6} style={{ borderRadius: 8 }} />
              <Skeleton width={236} height={46} style={{ borderRadius: 12 }} />
            </div>
          ))}

          {includeCssBlock ? (
            <div className="d-flex flex-column mt-4 gap-10">
              <Skeleton width={30} height={21.6} />
              <Skeleton width="100%" height={250} style={{ borderRadius: 12 }} />
            </div>
          ) : null}

          <Skeleton width={140} height={46} style={{ borderRadius: 12, marginTop: 33 }} />
        </div>

        <Skeleton
          width={320}
          height={370}
          style={{ borderTopLeftRadius: 8, borderTopRightRadius: 8, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}
        />
      </div>
    </div>
  );
};

export default ConsumerChannelsConfigSkeletons;
